import React from 'react'
import { NavigationContainer } from './styles'
import ScrollableStickyNav from '../../../../../app/components/ScrollableStickyNav'
import { StyledHeader } from '../../styles'
import ProductSelect from './ProductSelect'
import TopicNavList from './TopicNavList'

const DetailsNavigation = ({
  topics,
  products,
  currentProduct,
  focusedTopic,
  handleChange,
  performScroll
}) => (
  <NavigationContainer data-testid="paid-leave-detail-navigation">
    <ScrollableStickyNav>
      <StyledHeader>Paid Leave Type:</StyledHeader>
      <ProductSelect {...{
        currentProduct,
        products,
        handleChange
      }}
      />
      <TopicNavList {...{ topics, focusedTopic, performScroll }} />
    </ScrollableStickyNav>
  </NavigationContainer>
)


export default React.memo(DetailsNavigation)
